import { UploadIcon, XCircleIcon } from '@heroicons/react/solid';
import { useRef, useState } from 'react';

function MultiImageUploader({ name, current, fit = 'contain' }) {
    const hiddenInput = useRef();
    const uploadInput = useRef();
    const [currentImages, setCurrentImages] = useState(current ?? []);
    const [newImages, setNewImages] = useState([]);
    const [toBeDeleted, setToBeDeleted] = useState([]);

    function handleUpload() {
        const dt = new DataTransfer();
        [...hiddenInput.current.files].forEach((file) => {
            dt.items.add(file);
        });
        [...uploadInput.current.files].forEach((file) => {
            dt.items.add(file);
        });
        setNewImages((oldValue) => [...oldValue, ...[...uploadInput.current.files].map((file) => URL.createObjectURL(file))]);
        hiddenInput.current.files = dt.files;
    }

    function removeNew(index) {
        const dt = new DataTransfer();
        [...hiddenInput.current.files].forEach((file, i) => {
            if (index != i) dt.items.add(file);
        });
        hiddenInput.current.files = dt.files;
        setNewImages((oldValue) => {
            const newValue = [...oldValue];
            newValue.splice(index, 1);
            return newValue;
        });
    }

    function removeCurrent(id, index) {
        setToBeDeleted((oldValue) => [...oldValue, id]);
        setCurrentImages((oldValue) => {
            const newValue = [...oldValue];
            newValue.splice(index, 1);
            return newValue;
        });
    }

    return (
        <div className="relative inline-block h-full">
            <input ref={hiddenInput} className="hidden" name={`${name}[]`} type="file" accept="image/*" multiple />
            {toBeDeleted.map((id) => (
                <input type="hidden" name={`delete_${name}[]`} defaultValue={id} key={id} />
            ))}
            <div className="flex flex-wrap gap-4">
                {currentImages.length + newImages.length > 0 && (
                    <ul className="flex flex-wrap gap-4">
                        {currentImages.map(({ id, src }, index) => (
                            <li className="relative" key={index}>
                                <img className={`block h-[140px] max-w-[300px] ${fit == 'contain' ? 'object-contain' : 'object-cover'}`} src={src} />
                                <XCircleIcon
                                    className="absolute w-6 h-6 text-blue-600 bg-gray-100 rounded-full cursor-pointer -right-3 -top-3"
                                    onClick={() => {
                                        removeCurrent(id, index);
                                    }}
                                />
                            </li>
                        ))}
                        {newImages.map((preview, index) => (
                            <li className="relative" key={index}>
                                <img className={`block h-[140px] max-w-[300px] ${fit == 'contain' ? 'object-contain' : 'object-cover'}`} src={preview} />
                                <XCircleIcon
                                    className="absolute w-6 h-6 text-blue-600 bg-gray-100 rounded-full cursor-pointer -right-3 -top-3"
                                    onClick={() => {
                                        removeNew(index);
                                    }}
                                />
                            </li>
                        ))}
                    </ul>
                )}
                <label className="flex items-center justify-center h-full max-h-full overflow-hidden bg-gray-200 border border-gray-300 rounded-sm cursor-pointer">
                    <input ref={uploadInput} className="hidden" type="file" accept="image/*" multiple onChange={handleUpload} />
                    <div className="grid h-[140px] w-[140px] place-items-center">
                        <UploadIcon className="w-6 h-6 text-gray-400" />
                    </div>
                </label>
            </div>
        </div>
    );
}

export default MultiImageUploader;
